import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ContactusService } from '../contactus.service';
import { InfoDialogComponent } from '../info-dialog/info-dialog.component';
import { Contactus } from '../model/contactus.model';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {
  
  contactFormGroup: FormGroup;

  constructor(private dialog: MatDialog, private fb: FormBuilder, private contactusService: ContactusService) { }

  
  ngOnInit(): void {
    if(environment.googleMapsUrl && environment.googleMapsApiKey){
      const mapsUrl  = environment.googleMapsUrl + environment.googleMapsApiKey + "&loading=async&callback=initMap";
      this.loadExternalScript(mapsUrl).then(() => {}).catch(() => {});
    }

    this.contactFormGroup = this.fb.group({
      name: ['', Validators.required],
      email: ['', Validators.required],
      phone: '',
      message: ['', Validators.required],
    });
  }

  loadExternalScript(scriptUrl:string){
    return new Promise(resolve => {
      const scriptElement = document.createElement('script');
      scriptElement.src = scriptUrl;
      scriptElement.async = true; 
      scriptElement.onload = resolve;
      document.body.appendChild(scriptElement);
    });
  }

  save(){
    let contact =  new Contactus();
    contact = {...contact, ...this.contactFormGroup.value};
    this.contactusService.addContactUs(contact).then(()=>{
      const msg = "Your message has been delivered. We will get back to you as early as possible.";
      this.dialog.open(InfoDialogComponent,{ width: '350px', data: { message: msg } });

      this.resetForm();
    });
  }

  resetForm(){
    this.contactFormGroup.reset();
  }
}
